module.exports = __webpack_public_path__ + "img/wangguang.84ec17d1.png";